import { ArrowRightIcon } from "@heroicons/react/24/outline";
import Link from "next/link";
import { FC, ReactNode } from "react";
import Typography from "../Typography";

export type RelatedToolEntry = {
  name: string;
  description: string;
  href: string;
};

type RelatedToolsProps = {
  sectionTitle?: ReactNode;
  tools: RelatedToolEntry[];
};

const RelatedTools: FC<RelatedToolsProps> = ({
  sectionTitle = "More AI video tools",
  tools,
}) => {
  return (
    <section className="max-w-[1500px] px-3 md:px-12 mx-auto my-32 md:my-48">
      <Typography
        variant="h2"
        component="h2"
        className="text-center max-w-3xl mx-auto"
      >
        {sectionTitle}
      </Typography>
      <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {tools.map((tool) => (
          <Link
            key={tool.href}
            href={tool.href}
            className="group rounded-2xl border border-slate-200 bg-white p-6 hover:border-slate-300 hover:shadow-sm transition-all flex flex-col gap-3"
          >
            <div className="flex items-center justify-between">
              <Typography variant="subtitle1" className="text-slate-900">
                {tool.name}
              </Typography>
              <ArrowRightIcon className="w-4 h-4 text-slate-400 shrink-0 group-hover:translate-x-0.5 transition-transform" />
            </div>
            <Typography variant="body2" className="text-slate-500">
              {tool.description}
            </Typography>
          </Link>
        ))}
      </div>
    </section>
  );
};

export default RelatedTools;
